module.exports = __webpack_public_path__ + "images/Fulfillment_Ship.svg";